import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { routeCodes } from 'js/constants/routes';
import { clearSuggestion, setSearchStatusType } from 'js/actions/clapi';
import { invalidateCruxAppError } from 'js/actions/errorHandler';
import OTM from 'js/constants/otm';
import { isAU } from 'js/constants/crux';
import SuggestionTypes from 'js/constants/suggestionTypes';
import { getSuggestionTypeId } from '../../constants/msg/suggestionType';
import { saveRecentAddressSearches } from '../../actions/msgApi';
import SEGMENT from '../../constants/segment';

const useRedirection = (props) => {
    const history = useHistory();
    const dispatch = useDispatch();

    const handleHistoric = (isHistoric, searchParams) => {
        if (isAU && isHistoric) searchParams.set('active', 'false');
    };

    const handleStatusType = (statusType, searchParams) => {
        if (statusType !== OTM.ALL) searchParams.set('statusType', statusType)
    };

    const buildSuggestions = () => props.searches.map(search => search.suggestion).join('|');

    const buildUrlParams = () => {
        const searchParams = new URLSearchParams();

        if (props.searches?.length > 0) {
            searchParams.set('sType', props.searches[0].suggestionType);
            searchParams.set('suggestions', buildSuggestions());
        }

        handleHistoric(props.isHistoric, searchParams);
        handleStatusType(props.statusType, searchParams);

        return searchParams.toString();
    };

    return (mapSearch = false) => {
        const routePath = {
            pathname:  routeCodes.MULTI_LOCALITY_SEARCH.path,
            search: buildUrlParams(),
        };
        dispatch(setSearchStatusType(props.statusType));
        const isMapSearch = typeof mapSearch === 'boolean' ? mapSearch : false;
        if (isMapSearch) {
            props.trackMapEvent?.();
        }
        history.push(routePath, {
            entryPoint: SEGMENT.EVENT_PROPERTIES.SEARCH, mapSearch: isMapSearch,
        });
        dispatch(clearSuggestion());
        dispatch(invalidateCruxAppError());

        if (props.searches.length > 0) {
            props.trackSearchEvent?.();
            // Save recent searches if applicable
            const suggestions = buildSuggestions();
            const suggestionType = props.searches?.[0]?.suggestionType;

            const shouldSaveRecentSearch = isAU || suggestionType !== SuggestionTypes.POSTCODE;
            if (suggestions && shouldSaveRecentSearch) {
                dispatch(saveRecentAddressSearches(suggestions, getSuggestionTypeId(suggestionType)));
            }
        }
    }
};

useRedirection.propTypes = {
    searches: PropTypes.array,
    isHistoric: PropTypes.bool,
    statusType: PropTypes.string,
    entryPoint: PropTypes.string,
    trackSearchEvent: PropTypes.func,
    trackMapEvent: PropTypes.func,
};

export default useRedirection;
